import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useOrganizationContact from '../../hooks/useOrganizationContact';
import { AccentLink } from './PublicLegalPageLayout';

const Text = styled.p`
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const List = styled.ul`
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.8;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
`;

/** DPO — email cliquable + courrier paramétrable (SuperAdmin). */
export default function PrivacyDpoContact() {
  const { t } = useTranslation();
  const { organization, loading } = useOrganizationContact({ publicAccess: true });

  return (
    <>
      <Text>
        <strong>{t('privacyPage.contact.dpoTitle')}</strong>
      </Text>
      <List>
        <li>
          {loading ? (
            t('common.loading')
          ) : (
            <>
              {t('organizationContact.emailLabel')}{' '}
              <AccentLink href={organization.dpo.mailtoHref}>{organization.dpo.email}</AccentLink>
            </>
          )}
        </li>
        <li>
          {loading ? (
            t('common.loading')
          ) : (
            <>
              {t('organizationContact.mailLabel')} {organization.dpo.courrier}
            </>
          )}
        </li>
      </List>
    </>
  );
}
